import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const DatabaseSolutions = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="database-solutions">
        <div className="inner">
          <div className="content">
            <Title title={t("learn.database.solution.title")}></Title>
            <div className="feature-warp">
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">01</div>
                    <div className="headline">{t("learn.database.solution.item1.title")}</div>
                  </div>
                  <div className="list">{t("learn.database.solution.item1.list1")}</div>
                  <div className="list">{t("learn.database.solution.item1.list2")}</div>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">02</div>
                    <div className="headline">{t("learn.database.solution.item2.title")}</div>
                  </div>
                  <div className="list">{t("learn.database.solution.item2.list1")}</div>
                  <div className="list">{t("learn.database.solution.item2.list2")}</div>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">03</div>
                    <div className="headline">{t("learn.database.solution.item3.title")}</div>
                  </div>
                  <div className="list">{t("learn.database.solution.item3.list1")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
